import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import SummaryBookCard from '../../components/SummaryBookCard/SummaryBookCard';
import PersianBookCard from '../../components/PersianBookCard/PersianBookCard';
import toast from 'react-hot-toast';
import './CompletedBooks.css';

function CompletedBooks() {
    const [books, setBooks] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentUser, setCurrentUser] = useState(null);

    useEffect(() => {
        const userData = localStorage.getItem('currentUser');
        if (userData) {
            setCurrentUser(JSON.parse(userData));
        } else {
            window.location.href = '/login';
        }
    }, []);

    useEffect(() => {
        if (currentUser) {
            fetchCompletedBooks();
        }
    }, [currentUser]);

    const fetchCompletedBooks = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/user-book/completed/${currentUser._id}`);
            const userBooks = response.data.data;
            
            const bookPromises = userBooks.map(async (ub) => {
                const endpoint = ub.bookType === 'persian' ? 'persian-book' : 'summary-book';
                const bookRes = await axios.get(`${process.env.REACT_APP_API_URL}/${endpoint}/${ub.bookId}`);
                return { ...bookRes.data, bookType: ub.bookType, userBookId: ub._id };
            });
            
            const booksData = await Promise.all(bookPromises);
            setBooks(booksData);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching completed books:", error);
            setLoading(false);
        }
    };

    // تابع حذف کتاب از لیست مطالعه شده
    const removeFromList = async (userBookId, bookTitle) => {
        if (window.confirm(`آیا از حذف کتاب "${bookTitle}" از لیست مطالعه شده مطمئن هستید؟`)) {
            try {
                await axios.delete(`${process.env.REACT_APP_API_URL}/user-book/remove/${currentUser._id}/${userBookId}`);
                toast.success('کتاب از لیست مطالعه شده حذف شد');
                setBooks(books.filter(book => book.userBookId !== userBookId));
            } catch (error) {
                console.error("Error removing book:", error);
                toast.error('خطا در حذف کتاب');
            }
        }
    };

    if (loading) {
        return (
            <>
                <Navbar />
                <div className="loading-container">در حال بارگذاری...</div>
                <Footer />
            </>
        );
    }

    return (
        <>
            <Navbar />
            <div className="completed-books-container">
                <div className="container mt-4">
                    <h2 className="text-center mb-4">✅ کتاب‌های مطالعه شده</h2>
                    {books.length > 0 ? (
                        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
                            {books.map(book => {
                                const BookComponent = book.bookType === 'persian' ? PersianBookCard : SummaryBookCard;
                                return (
                                    <div key={book._id} className="book-card-wrapper">
                                        <BookComponent {...book} />
                                        <button 
                                            className="remove-from-list-btn"
                                            onClick={() => removeFromList(book.userBookId, book.title)}
                                        >
                                            🗑️ حذف از لیست
                                        </button>
                                    </div>
                                );
                            })}
                        </div>
                    ) : (
                        <div className="empty-state">
                            <p>هنوز کتابی مطالعه نکرده‌اید.</p>
                            <a href="/summary-books" className="btn-start-reading">شروع مطالعه</a>
                        </div>
                    )}
                </div>
            </div>
            <Footer />
        </>
    );
}

export default CompletedBooks;